// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__9fd6i","col":"styles_col__2bPty"};